// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__D-tZl","modalContent":"Modal_modalContent__q1YDC","btn":"Modal_btn__zmDbB"};